import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'

export const ThemeContext = React.createContext({})
const THEME_KEY = 'theme'
const DARK_THEME = 'dark'
const LIGHT_THEME = 'light'

export default observer(function ThemeProvider({ children }) {
  const themeState = useLocalObservable(() => {
    const savedTheme = typeof window !== 'undefined' ? localStorage.getItem(THEME_KEY) : null
    const prefersDark = typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)').matches : false
    const isDark = savedTheme === DARK_THEME || (!savedTheme && prefersDark)

    return {
      isDark: isDark,
      setTheme(nextTheme) {
        this.isDark = nextTheme === DARK_THEME
        localStorage.setItem(THEME_KEY, this.isDark ? DARK_THEME : LIGHT_THEME)
      },
      toggleTheme() {
        this.setTheme(this.isDark ? LIGHT_THEME : DARK_THEME)
      }
    }
  })

  useEffect(() => {
    if (themeState.isDark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [themeState.isDark])

  return (
    <ThemeContext.Provider value={{ themeState }}>
      {children}
    </ThemeContext.Provider>
  )
})
